import { render, staticRenderFns } from "./BackOrderPopup.vue?vue&type=template&id=34cabb05"
import script from "./BackOrderPopup.vue?vue&type=script&lang=js"
export * from "./BackOrderPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports